import styled from 'styled-components';

import SegmentedControl from 'components/shared/SegmentedControl';
import { useReferralsInsightsActions, useReferralsInsightsStore } from 'stores/referralsInsightsStore';
import { Label } from 'styles/typography';

import ReferralHighlightsCard from './highlights/ReferralHighlightsCard';
import useReferralAnalytics from './query/useReferralAnalytics';
import ReferralInsightsSlideout from './slideout/ReferralInsightsSlideout';
import ReferralDetailsSection from './table/ReferralDetailsSection';
import { getReferralDetailsParams, VIEW_BY, VIEW_BY_DIMENSION_MAP, ViewByValue, withDimensionIds } from './constants';
import { useReferralsInsightsContext } from './ReferralsContainer';

const ReferralsDashboard = () => {
  const { sendingGroupType } = useReferralsInsightsContext();
  const selectedReceivingGroupType = useReferralsInsightsStore((state) => state.selectedReceivingGroupType);
  const viewBy = useReferralsInsightsStore((state) => state.viewBy);
  const { setViewBy } = useReferralsInsightsActions();

  const sendingGroupTypeName = sendingGroupType?.displayName ?? '';
  const receivingGroupTypeName = selectedReceivingGroupType?.displayName ?? '';
  const dimension = VIEW_BY_DIMENSION_MAP[viewBy];

  const { loading, data, rollups } = useReferralAnalytics(withDimensionIds(getReferralDetailsParams(dimension)));

  const viewByOptions = [
    { label: `Referring ${sendingGroupTypeName}`, value: VIEW_BY.SENDING_GROUP },
    { label: `${receivingGroupTypeName} Company`, value: VIEW_BY.RECEIVING_CLIENT },
    { label: 'Plan', value: VIEW_BY.HEALTH_PLAN },
  ];

  return (
    <>
      <DashboardWrapper>
        <ViewByRow>
          <ViewByLabel>View By:</ViewByLabel>
          <SegmentedControl
            options={viewByOptions}
            selectedValue={viewBy}
            onChange={(val) => setViewBy(val as ViewByValue)}
            mobileFullWidth
          />
        </ViewByRow>
        <ReferralHighlightsCard loading={loading} data={data} rollups={rollups} />
        <ReferralDetailsSection loading={loading} rollups={rollups} />
      </DashboardWrapper>
      <ReferralInsightsSlideout />
    </>
  );
};

export default ReferralsDashboard;

const DashboardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin: 0 auto 24px auto;
    max-width: 1280px;
    width: 100%;
  }
`;

const ViewByRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ViewByLabel = styled(Label)`
  color: ${({ theme }) => theme.colors.black75};

  @media (max-width: 800px) {
    display: none;
  }
`;
